module.exports = __webpack_public_path__ + "static/media/Forestry-BG-Back-Layer-Four.a41930a1.png";